module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_j_normal.a97e346a.png";